/**
 Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export const EnvBannerHeight = process.env.NODE_ENV === 'development' ? 28 : 0;
export const PagesHeightWithEnvBanner = `calc(100vh - ${EnvBannerHeight}px)`;

export const SidebarWidth = 'calc(30.625 * 8px)';
